import React from 'react'
import { Box } from '@mui/material'
import { INTERAX_COLORS } from '../constants/colors'

interface SessionDateBlockProps {
  day: number
  month: string
}

export const SessionDateBlock: React.FC<SessionDateBlockProps> = ({ day, month }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        minWidth: '60px',
        flex: '0 0 auto'
      }}
    >
      <Box
        sx={{
          fontSize: '1.875rem',
          fontWeight: 'bold',
          color: INTERAX_COLORS.sun
        }}
      >
        {day}
      </Box>
      <Box
        sx={{
          fontSize: '0.875rem',
          fontWeight: '500',
          color: INTERAX_COLORS.thunderGrey
        }}
      >
        {month}
      </Box>
    </Box>
  )
}

export default SessionDateBlock
